import { getProductCategories } from "../data/products";

// Normalize the catalog's format terms without broad stemming or fuzzy matches.
const normalizeSearch = (value) => String(value).toLowerCase()
  .replace(/\b(sheets|tablets|pods|powders|beads|wipes|kits|bottles|balls|pens)\b/g, (word) => word.slice(0, -1))
  .replace(/\baccessories\b/g, "accessory")
  .replace(/[^a-z0-9]+/g, " ").trim();

export function matchesProductSearch(product, query) {
  const identifierQuery = String(query).trim().toLowerCase();
  if (/^kl(?:p)?[-_][a-z0-9_-]+$/.test(identifierQuery)) {
    return [product.sku, product.catalogSku || ""].some((sku) => sku.toLowerCase().includes(identifierQuery));
  }
  const terms = normalizeSearch(query).split(/\s+/).filter(Boolean);
  const searchable = normalizeSearch([
    product.name, product.sku, product.catalogSku || "",
    ...getProductCategories(product).map(({ name }) => name),
  ].join(" "));
  return terms.every((term) => searchable.includes(term));
}

// Group only the applications already named in this catalog. Related products
// are alternatives for a buyer's task, not just the first records in a format.
const applications = [
  /laundry|dryer|color.catcher|color.absorbing|fabric softener|fragrance|stain removal/i,
  /dishwash/i,
  /multi.purpose|floor cleaning|plastic spray bottle/i,
  /glass cleaning|glass spray bottle/i,
  /hand soap|foaming bottle/i,
  /toilet bowl/i,
  /coffee machine/i,
  /baby.*bottle cleaning/i,
];
const specialistApplications = [
  /dryer|fabric softener/i,
  /color.catcher|color.absorbing|dyeing/i,
  /fragrance/i,
  /stain removal/i,
  /machine.*cleaning|laundry machine/i,
];
const relatedSkuPreferences = {
  // The combined kit names these three separate tablet applications.
  "KL-HCT-KT": ["KL-LDT-RG", "KL-DDT-RG", "KL-MPCT-RG"],
  // A foaming dispenser goes with refill formats, not palm-lather soap sheets.
  "KL-FBT-GL": ["KL-HSS-CT", "KL-HST-RG", "KL-HST-KT"],
};

export function getRelatedProducts(product, catalog, limit = 3) {
  const contexts = applications.filter((pattern) => pattern.test(product.name));
  const specialties = specialistApplications.filter((pattern) => pattern.test(product.name));
  const family = product.sku.split("-").slice(0, 2).join("-");
  const preferred = relatedSkuPreferences[product.sku] || [];
  return catalog.filter((candidate) => candidate.slug !== product.slug)
    .map((candidate, index) => {
      const sharedApplications = contexts.filter((pattern) => pattern.test(candidate.name)).length;
      const preference = preferred.indexOf(candidate.sku);
      return {
        candidate, index,
        relevance: (preference >= 0 ? 100 - preference : 0) + sharedApplications * 10
          + (sharedApplications ? specialties.filter((pattern) => pattern.test(candidate.name)).length * 20 : 0)
          + (candidate.sku.split("-").slice(0, 2).join("-") === family ? 30 : 0),
      };
    })
    .filter(({ relevance }) => relevance > 0)
    .sort((a, b) => b.relevance - a.relevance || a.index - b.index)
    .slice(0, limit).map(({ candidate }) => candidate);
}
